<mojo-navbar></mojo-navbar>
<mojo-page-title title="Cancel Activities"></mojo-page-title>

<p-confirmDialog header="Confirmation"></p-confirmDialog>

<section class="panel data-table full-page-widget mojo-admin-page full-page-scrollable">
  <div class="panel-body">

    <ng-container widget-content>
      <div class="flex table-caption">
        <input class="flex flex-grow-1" pInputText type="text"
               (input)="primeNgTable.filterGlobal($event.target.value, 'contains')" placeholder="Search..."/>
        <button pButton class="p-button-outlined" (click)="export()" pTooltip="CSV" tooltipPosition="bottom">
          <i class="fa fa-download fa-lg" aria-hidden="true"></i>
        </button>

        <button pButton label="Clear" class="p-button-outlined" icon="pi pi-filter-slash"
                (click)="clear()"></button>

      </div>
      <p-table #primeNgTable
               [columns]="cols"
               [exportFunction]="exportFunction"
               [value]="activities$ | async" responsiveLayout="scroll" selectionMode="multiple"
               [resizableColumns]="true"
               [globalFilterFields]="[ 'FormRef', 'ActivityName','ActivityDetails', 'Assignee', 'Workgroup', 'Status' ]"
               [scrollable]="true"
               (onFilter)="handleFilter($event)"
               showCurrentPageReport="true"
               scrollHeight="flex"
               [(selection)]="selectedForms"
               dataKey="FormRef"
               (sortFunction)="customSort($event)"
               [customSort]="true"
               [loading]="cancelInProgress | async" loadingIcon="fa fa-spinner fa-spin">>

        <ng-template pTemplate="header">
          <tr>
            <th class="overflow-hidden" pSortableColumn="FormRef">
              <div class="flex justify-content-center align-items-center">
                <p-sortIcon field="FormRef"></p-sortIcon>
                <span>Form Ref </span>
                <p-columnFilter type="numeric" field="FormRef" display="menu"></p-columnFilter>
              </div>
            </th>
            <th class="overflow-hidden" pSortableColumn="DateCreated">
              <p-sortIcon field="DateCreated"></p-sortIcon>
              <span>Date Created </span>
              <p-columnFilter type="date" field="DateCreated" display="menu"></p-columnFilter>
            </th>
            <th class="overflow-hidden" pSortableColumn="ActivityName">
              <p-sortIcon field="ActivityName"></p-sortIcon>
              <span>Name </span>
              <p-columnFilter type="text" field="ActivityName" display="menu"></p-columnFilter>
            </th>
            <th pSortableColumn="ActivityDetails" class="overflow-hidden" style="flex: 0 0 30%">
              <p-sortIcon field="ActivityDetails"></p-sortIcon>
              <span>Details </span>
              <p-columnFilter type="text" field="ActivityDetails" display="menu"></p-columnFilter>
            </th>
            <th class="overflow-hidden" pSortableColumn="Assignee">
              <p-sortIcon field="Assignee"></p-sortIcon>
              <span>Assignee </span>
              <p-columnFilter type="text" field="Assignee" display="menu"></p-columnFilter>
            </th>
            <th class="overflow-hidden" pSortableColumn="Workgroup">
              <p-sortIcon field="Workgroup"></p-sortIcon>
              <span>Workgroup </span>
              <p-columnFilter type="text" field="Workgroup" display="menu"></p-columnFilter>
            </th>
            <th class="overflow-hidden" pSortableColumn="Status">
              <p-sortIcon field="Status"></p-sortIcon>
              <span>Status </span>
              <p-columnFilter type="text" field="Status" display="menu"></p-columnFilter>
            </th>
            <th pSortableColumn="checkbox" class="justify-content-center align-items-center overflow-hidden">
              <p-sortIcon field="checkbox"></p-sortIcon>
              <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-activity>
          <tr>
            <td>{{ activity.FormRef }}</td>
            <td>{{ activity.DateCreated | date:'dd MMM yyyy' }}</td>
            <td>{{ activity.ActivityName }}</td>
            <td>
              {{ activity.ActivityDetailsLine1 }} - {{ activity.ActivityDetailsLine2 }}<br/>
              {{ activity.ActivityDetailsLine3 }}
            </td>
            <td>{{ activity.Assignee }}</td>
            <td>{{ activity.Workgroup }}</td>
            <td>{{ activity.Status }}</td>
            <td class="justify-content-center align-items-center">
              <p-tableCheckbox [value]="activity"></p-tableCheckbox>
            </td>

          </tr>
        </ng-template>
      </p-table>

      <p-toolbar>
        <div class="p-toolbar-group-left">
          <h4>Showing {{ filteredRowCount }} of {{ (recordCount$() | async) }} Records Found</h4>
        </div>
        <div class="p-toolbar-group-right">
          <p-button [disabled]="disableCancel()" (click)="handleCancelForms()" label="Cancel Selected Forms"></p-button>
        </div>
      </p-toolbar>
    </ng-container>

  </div>
</section>
